import { Button, Form } from 'antd'
import { SelectButton } from 'components/atoms'
import { StyledSearchInput } from 'components/templates/headerNotification/index.styled'
import styled from 'styled-components'

export const StyleContentWrapper = styled(Form)`
  display: flex;
  align-items: end;
  gap: 20px;
  justify-content: space-between;
`

export const StyleButtonFilter = styled(Button)`
  background-color: #0061f4;
  border-radius: 8px;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: #0061f4;
  }
`

export const StyleLable = styled.label`
  color: #09101d;
  font-weight: 500;
  display: block;
  margin-bottom: 5px;
`

export const StyleForm = styled(Form)`
  display: flex;
  align-items: flex-end;
  gap: 20px;
  margin-top: 10px;
`

export const StyleButtonFind = styled(Button)`
  margin-bottom: 16px;
  background-color: #0061f4;
  border-radius: 8px;
  text-transform: uppercase;
`

export const StyleFormItem = styled(Form.Item)`
  margin-bottom: 0px;
`

export const StyledSearch = styled(StyledSearchInput)`
  height: 40px;
  width: 300px;
`

export const StyledSelectButton = styled(SelectButton)`
  width: 100px !important;
`

export const StyledFilter = styled.div`
  display: flex;
  align-items: end;
  justify-content: center;
  gap: 8px;
`
export const StyledBtnFilter = styled.div`
  display: flex;
  align-items: end;
  justify-content: center;
  gap: 8px;
`
